import React, { useState, useEffect } from "react";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "antd";
import TaskTable from "./taskTable";
import "./index.less";

const Component = () => {
  const { state, actions } = useAppContext();
  const location = useLocation();
  const navigate = useNavigate(); // 路由跳转方法
  const params = useParams(); // 获取路由路径参数（k/f）
  const projectId = params.k; // 对应/project/:k/flow/:f/design中的k
  const flowId = params.f;   // 对应/project/:k/flow/:f/design中的f

  useEffect(() => {
    // 解析URL参数并更新状态
    const params = new URLSearchParams(location.search);
    // const projectId = params.get("k");
    // const flowId = params.get("f");
    const taskId = params.get("j");
    actions.loadData();
    // 执行数据加载逻辑
  }, [location.search]);

  return (
    <ReactFlowProvider>
      {state.curFlow && state.curProject && state.projectList ? (
        <>
          <PageTop
            mainContent={
              <div className="settingSelectorArea">
                <PageSeletor />
              </div>
            }
          />
          <div className="mainContent">
            <div className="mainTask">
              <TaskTable projectId={projectId} flowId={flowId} />
            </div>
          </div>

        </>
      ) : null}
    </ReactFlowProvider>
  );
};

export default Component;
